<div
  fxLayout="column"
  class="notifications-container"
  [class.force-view-height]="pageSize <= 11 || loading"
  >
  <div class="notification-header" fxLayout="row" fxLayoutAlign="left center">
    <span class="with-icon"> <mat-icon>mail</mat-icon>Messages </span>
    <span class="fill-remaining-space"></span>
    <button (click)="closeSideNav()" aria-label="Close" title="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div fxFlex class="notifications">
    <mat-tab-group
      (selectedTabChange)="onSelectChange($event)"
      [disableRipple]="true"
      [dynamicHeight]="true"
      [selectedIndex]="selectedTab"
      >
      <!-- Inbox -->
      <mat-tab>
        <!-- Tab Label -->
        <ng-template mat-tab-label>
          <div class="mat-tab-label-inner-content selected-tab">
            <div class="matIconWrapper">
              <mat-icon>inbox</mat-icon>
            </div>
            <div class="matLabelText">Inbox</div>
          </div>
        </ng-template>

        <!-- Loading Spinner -->
        @if (loading) {
          <div
            fxLayoutAlign="center center"
            class="spinner-box"
            >
            <mat-spinner diameter="40"></mat-spinner>
          </div>
        }

        <!-- Messages -->
        @if (!loading) {
          <div
            fxLayout="column"
            fxLayoutAlign="space-between"
            class="fill-vertical"
            >
            <notifications-list
              [notifications]="notifications"
              (markAsRead)="markAsRead($event)"
              (archive)="archive($event)"
              (sendReplyEvent)="sendReply($event)"
              class="notifications-list"
              >
            </notifications-list>
            <mat-paginator
              class="notification-list-paginator"
              [length]="pagedNotifications?.total"
              [pageSize]="pageSize"
              [pageIndex]="pageIndex"
              [pageSizeOptions]="pageSizeOptions"
              (page)="getNotifications('inbox', $event)"
              >
            </mat-paginator>
          </div>
        }
      </mat-tab>

      <!-- Sent -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="mat-tab-label-inner-content">
            <div class="matIconWrapper">
              <mat-icon>send</mat-icon>
            </div>
            <div class="matLabelText">Sent</div>
          </div>
        </ng-template>

        @if (loading) {
          <div
            fxLayoutAlign="center center"
            class="spinner-box"
            >
            <mat-spinner diameter="40"></mat-spinner>
          </div>
        }

        @if (!loading) {
          <div
            fxLayout="column"
            fxLayoutAlign="space-between"
            class="fill-vertical"
            >
            <notifications-sent
              [notifications]="notificationsSent"
              (editNotificationEvent)="saveEdit($event)"
              (deleteNotificationEvent)="deleteNotification($event)"
              class="notifications-sent"
              >
            </notifications-sent>
            <mat-paginator
              class="notification-list-paginator"
              [length]="pagedNotificationsSent?.total"
              [pageSize]="pageSize"
              [pageIndex]="pageIndex"
              [pageSizeOptions]="pageSizeOptions"
              (page)="getNotifications('sent', $event)"
              >
            </mat-paginator>
          </div>
        }
      </mat-tab>

      <!-- Archived -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="mat-tab-label-inner-content">
            <div class="matIconWrapper">
              <mat-icon
                                [ngStyle]="{
                                    color: '#7f8c8d',
                                    'font-size': '18px'
                                }"
                [inline]="true"
                fontSet="fa"
                fontIcon="fa-archive"
              ></mat-icon>
            </div>
            <div class="matLabelText">Archived</div>
          </div>
        </ng-template>
        @if (loading) {
          <div
            fxLayoutAlign="center center"
            class="spinner-box"
            >
            <mat-spinner diameter="40"></mat-spinner>
          </div>
        }

        @if (!loading) {
          <div
            fxLayout="column"
            fxLayoutAlign="space-between"
            class="fill-vertical"
            >
            <notifications-list
              [notifications]="notificationsArchived"
              (restore)="restore($event)"
              class="notifications-list"
            ></notifications-list>
            <mat-paginator
              class="notification-list-paginator"
              [length]="pagedNotificationsArchived?.total"
              [pageSize]="pageSize"
              [pageIndex]="pageIndex"
              [pageSizeOptions]="pageSizeOptions"
              (page)="getNotifications('archived', $event)"
              >
            </mat-paginator>
          </div>
        }
      </mat-tab>

      <!-- Compose -->
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="mat-tab-label-inner-content">
            <div class="matIconWrapper">
              <mat-icon aria-label="Compose">add</mat-icon>
            </div>
            <div class="matLabelText">Compose</div>
          </div>
        </ng-template>
        @if (isDistributor$ | async) {
          <div>
            <new-notification
              (goToInbox)="goToInbox()"
            ></new-notification>
          </div>
        }
        @if (isTeacher$ | async) {
          <div>
            <new-notification
              (goToInbox)="goToInbox()"
            ></new-notification>
          </div>
        }
        @if (isStudent$ | async) {
          <div>
            <new-pm (goToInbox)="goToInbox()"></new-pm>
          </div>
        }
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
